import _ from 'lodash';
import { eventInitOf, REGISTER_EVENT_NAME, REGISTER_EVENT_OPTIONS } from './common';
export class RegisterEvent extends CustomEvent {
    constructor(injectable, options = {}) {
        super(REGISTER_EVENT_NAME, Object.assign(Object.assign(Object.assign({}, REGISTER_EVENT_OPTIONS), options), { detail: { injectable } }));
        this.version = 'v1';
        this.dependencies = new Map();
    }
    putIfAbsent(key, value) {
        if (this.dependencies.has(key)) {
            return false;
        }
        this.dependencies.set(key, value);
        return true;
    }
    static from(event) {
        const clone = new RegisterEvent(event.detail.injectable, eventInitOf(event));
        _.merge(clone, {
            dependencies: new Map([...event.dependencies]),
        });
        return clone;
    }
}
//# sourceMappingURL=v1.js.map